document.addEventListener('DOMContentLoaded', () => {
  const ribbon_image = 'https://cdn.shopify.com/s/files/1/0871/5558/files/Customizable_Jerseys.png?v=1742860154';
  const totalProducts = window.store_total_products;
  const productsPerPage = 250;
  const totalPages = Math.ceil(totalProducts / productsPerPage);
  function fetchProductsFromApi(page) {
    const url = `https://soccerwearhouse.com/collections/customized-products/products.json?limit=${productsPerPage}&page=${page}`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        data.products.forEach(product => {
          const handle = product.handle;

          if (product.tags && product.tags.includes('customjersey')) {
            // If product is not already in productsMap, add it
            if (!window.productsMap[handle]) {
              window.productsMap[handle] = {
                url: product.url,
                handle: product.handle,
                id: product.id
              };
            }
          }
        });

        // After fetching the products from the current page, continue fetching for next pages
        if (page < totalPages) {
          fetchProductsFromApi(page + 1);  // Recursively fetch next page
        } else {
          // Once all pages are fetched, execute the addRibbon logic
          document.querySelectorAll('.ss__result--item').forEach(addRibbon);
        }
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }
  // Slick slider initialization
  $('.featured-collections-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // Add Discount Label
  function addDiscountLabel(detail) {
    const msrpElement = detail.querySelector('.ss__result__msrp');
    const salePriceElement = detail.querySelector('.ss__result__price--on-sale');
    const pricingElement = detail.querySelector('.ss__result__pricing');
    const imageElement = detail.closest('.ss__result__inner').querySelector('.ss__result__image__wrapper');

    if (msrpElement && salePriceElement) {
      const msrp = parseFloat(msrpElement.textContent.replace('$', ''));
      const salePrice = parseFloat(salePriceElement.textContent.replace('$', ''));
      const savings = Math.ceil(msrp - salePrice);
      let discountLabelText;

      if (salePrice > 75) {
        discountLabelText = 'Save $' + savings;
      } else {
        const discountPercentage = Math.round((savings / msrp) * 100);
        discountLabelText = discountPercentage + '% off';
      }

      if (!detail.querySelector('.ss_discount_label') && !detail.querySelector('.ss_discount_label_text')) {
        const discountLabel = document.createElement('p');
        discountLabel.classList.add('ss_discount_label_text');
        discountLabel.textContent = discountLabelText;

        const discountLabelTag = document.createElement('p');
        discountLabelTag.classList.add('ss_discount_label');
        discountLabelTag.textContent = 'Sale';

        pricingElement.insertAdjacentElement('afterend', discountLabel);
        imageElement.insertAdjacentElement('afterend', discountLabelTag);
      }
    }
  }
  // Add CTA Button
  function addCta(ssItem) {
    const imageLinkElement = ssItem.querySelector('.ss__result__image__link');
    if (imageLinkElement && !ssItem.querySelector('.ss_cta_button')) {
      const href = imageLinkElement.getAttribute('href');
      const ctaElement = document.createElement('a');
      ctaElement.textContent = 'Shop Now';
      ctaElement.href = href;
      ctaElement.classList.add('ss_cta_button', 'custom_btn');
      ssItem.appendChild(ctaElement);
    }
  }

  // Mutation observer for dynamically added content
  function observeResultsContainer() {
    const parentNode = document.body;

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.classList && node.classList.contains('ss__results')) {
            observeResultsContent(node);
          }
        });
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(parentNode, config);
  }

  function observeResultsContent(ssTargetNode) {
    const contentObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((addedNode) => {
            if (addedNode.classList && addedNode.classList.contains('ss__result__details')) {
              addDiscountLabel(addedNode);  // Apply discount label to the newly added result detail
            }
            if (addedNode.classList && addedNode.classList.contains('ss__result--item')) {
              addCta(addedNode); 
              addRibbon(addedNode);// Apply CTA button to the newly added result item
            }
          });
          
        }
      });
    });

    const ssConfig = { childList: true, subtree: true };
    contentObserver.observe(ssTargetNode, ssConfig);
  }
  function addRibbon(item) {
    const link = item.querySelector(".ss__result__image__link");
    const productUrl = link.href; 
    const handle = productUrl.split('/products/')[1].split('?')[0];
   
    if (window.productsMap[handle]) {
      const existingRibbon = item.querySelector('.ribbon');
      if (!existingRibbon) {
        const ribbon = document.createElement('div');
        ribbon.classList.add('ribbon', 'ribbon-top-left');  // Add the class for top-left ribbon
        
        ribbon.setAttribute("data-label",'Customizeable');
        const resultItems = document.querySelectorAll('.ss__result--item');
        //ribbon.innerText = 'Customizable';
        // Loop through the items and append the ribbon
        item.appendChild(ribbon.cloneNode(true));
        console.log(item);
      }
    }
  }

  // Wait for specific element to be available
  function waitForElement(selector, callback) {
    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        callback(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  // Initialize
  observeResultsContainer();
  waitForElement('.ss__results', () => {
    // If elements are already available, we can apply the logic
    document.querySelectorAll('.ss__result__details').forEach(addDiscountLabel);
    document.querySelectorAll('.ss__result--item').forEach(addCta);
    document.querySelectorAll('.ss__result--item').forEach(addRibbon);
    //addRibbon();
  });
  fetchProductsFromApi(1);
});